import { View } from 'react-native'
import React from 'react'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import { useBaseInputStyle } from '@linqpal/common-frontend/src/ions/style'
import { useTheme } from 'react-native-paper'

export const InputFieldContainer = (props) => (
  <View
    style={{ flexDirection: 'row', alignItems: 'center', height: '100%' }}
    {...props}
  />
)

export const InputFieldOuterContainer = ({
  focused,
  style,
  error,
  ...props
}) => {
  const { inputBackgroundColor } = useBaseInputStyle()
  const {
    colors: { accentText, accent, tertiaryLight },
  } = useTheme()

  return (
    <View
      style={composeStyle(
        inputBackgroundColor,
        {
          borderColor: focused ? accentText : '#E5E5E5',
          borderWidth: 1,
          borderRadius: 8,
          marginTop: 24,
          paddingBottom: 1,
          overflow: 'hidden',
        },
        style,
        error ? { borderColor: accent } : {},
      )}
      {...props}
    />
  )
}
